
const RadioSkeleton = () => {
  const radios = {
    backgroundColor: "#e5e7eb",
    height: "20px",
    borderRadius: "3px",
    padding: "6px",
  };
  return (
    <div>
      <div className="w-50 my-2 animate-pulse" style={radios}></div>
      <div className="w-50 my-2 animate-pulse" style={radios}></div>
      <div className="w-50 my-2 animate-pulse" style={radios}></div>
      <div className="w-50 my-2 animate-pulse" style={radios}></div>
    </div>
  );
};

export default RadioSkeleton;
